class Config {
  constructor(buildData) {
    this.env = buildData.env;
    this.serverUrl = buildData.serverUrl;
    this.googleAnalitic = buildData.googleAnalitic;
    this.appName = buildData.appName;
    this.demoToken = buildData.demoToken;
    this.demo = buildData.demo;
  }

  createConfigView() {
    return new ConfigView(this);
  }
  removeDemoToken() {
    this.demoToken = "";
  }
}

class ConfigView {
  constructor(config) {
    this.serverUrl = config.serverUrl;
    this.appName = config.appName;
  }
}

class ConfigBuilder {
  setServerUrl(val) {
    this.serverUrl = val;
    return this;
  }

  setGoogleAnalitic(val) {
    this.googleAnalitic = val;
    return this;
  }

  setEnv(val) {
    this.env = val;
    return this;
  }

  setAppName(val) {
    this.appName = val;
    return this;
  }

  setDemo(val) {
    this.demo = val;
    return this;
  }

  setDemoToken(val) {
    this.demoToken = val;
    return this;
  }

  build() {
    return new Config(this);
  }
}

function getConfigBuilder() {
  return new ConfigBuilder();
}

export default {
  getConfigBuilder,
};
